import { z } from "zod";

export const PaginationCursorSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type PaginationCursor = z.infer<typeof PaginationCursorSchema>;

export const PaginationOffsetSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type PaginationOffset = z.infer<typeof PaginationOffsetSchema>;

export const UuidSchema = z.string().uuid();

// Spec 081 — o tipo de perda deixou de ser exclusivo do registro de refugo: o contador de papel
// `SCRAPS` também o declara, de uma vez, na configuração. Vive aqui porque agora é vocabulário de
// dois domínios (`production.ts` e `parameters.ts`), e duas cópias divergiriam no primeiro valor novo.
// O TIPO `LossType` já vem do Prisma via `entities/index.ts` — não redeclarar aqui, senão o
// barrel exporta dois membros com o mesmo nome (TS2308).
export const LossTypeSchema = z.enum(["REJECT", "WASTE", "REWORK"]);

// --- Route param schemas -----------------------------------------------------
// Tier3 (revisa): TODA definição Zod vive em shared-types —
// inclusive params de URL, que antes ficavam locais nas rotas com
// `eslint-disable no-restricted-imports`. Convenção contract-first sem exceção
// (ver). Rotas importam estes em vez de declarar `z.object` inline.
export const IdParamsSchema = z.object({ id: UuidSchema });
export const LineIdParamsSchema = z.object({ lineId: UuidSchema });
// Spec 082 — meta de período, aninhada sob a linha.
export const TargetIdParamsSchema = z.object({ lineId: UuidSchema, targetId: UuidSchema });
export const MachineIdParamsSchema = z.object({ machineId: UuidSchema });
export const DeviceIdParamsSchema = z.object({ deviceId: UuidSchema });
export const AlarmIdParamsSchema = z.object({ alarmId: UuidSchema });
export const ScenarioIdParamsSchema = z.object({ scenarioId: UuidSchema });
export const LinkIdParamsSchema = z.object({ linkId: UuidSchema });
export const FileKeyParamsSchema = z.object({ fileKey: z.string().min(1) });
export const LineNodeParamsSchema = z.object({ lineId: UuidSchema, nodeId: UuidSchema });
export const LineEdgeParamsSchema = z.object({ lineId: UuidSchema, edgeId: UuidSchema });
export const LineMachineParamsSchema = z.object({ lineId: UuidSchema, machineId: UuidSchema });
export const LineRunParamsSchema = z.object({ lineId: UuidSchema, runId: UuidSchema });
// Spec 078
export const Model3dIdParamsSchema = z.object({ id: UuidSchema });
export const MachineParameterParamsSchema = z.object({
  machineId: UuidSchema,
  parameterId: UuidSchema,
});

// Coerção correta de boolean em query string. NÃO usar z.coerce.boolean() (= Boolean(str),
// que torna "false"/"0" → true). Aceita "true"/"1" → true, "false"/"0" → false; ausência → undefined.
export const BooleanQueryParamSchema = z
  .enum(["true", "false", "1", "0"])
  .transform((v) => v === "true" || v === "1");
export type Uuid = z.infer<typeof UuidSchema>;
